import React from 'react';
import { FormattedMessage } from 'react-intl';
import Tooltip from '@components/common/tooltip/Tooltip';
import { getCurrency } from '@utils/tools/currencyTools';
import { IAmountDisplayProps } from '../../types';

// ============================================================================
// Component
// ============================================================================

const AmountDisplay: React.FC<IAmountDisplayProps> = ({ amount, labelId, tooltipContent, tooltipIndex }) => (
    <div className="margin-bottom-1">
        <Tooltip
            id={<FormattedMessage id={labelId} />}
            content={tooltipContent}
            index={tooltipIndex}
        />
        <div className="text-bold margin-top-05">
            <FormattedMessage id="historical.member.applications.perMonth" values={{ amount: getCurrency(Number(amount)) }} />
        </div>
    </div>
);

export default AmountDisplay;
